import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { LanguageProvider } from './context/LanguageContext';
import { ThemeProvider } from './context/ThemeContext';
import { Toaster } from './components/ui/sonner';

import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ProtectedRoute from './components/ProtectedRoute';

import Landing from './pages/Landing';
import Login from './pages/Login';
import Register from './pages/Register';
import ProSignup from './pages/ProSignup';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Dashboard from './pages/Dashboard';
import PersonalDateSelection from './pages/PersonalDateSelection';
import EnergyChart from './pages/EnergyChart';
import AdminEnergyChart from './pages/AdminEnergyChart';
import AdminDashboard from './pages/AdminDashboard';
import GuestProfiles from './pages/GuestProfiles';
import PersonalAnalysis from './pages/PersonalAnalysis';
import CrimsonHorse from './pages/CrimsonHorse';
import Settings from './pages/Settings';
import Subscription from './pages/Subscription';
import SubscriptionSuccess from './pages/SubscriptionSuccess';
import SubscriptionCancel from './pages/SubscriptionCancel';
import HairCuttingDays from './pages/HairCuttingDays';

import './index.css';

function App() {
    return (
        <ThemeProvider>
            <LanguageProvider>
                <AuthProvider>
                    <BrowserRouter>
                        <div className="min-h-screen bg-background flex flex-col">
                            <Navbar />
                            <main className="flex-1">
                                <Routes>
                                    <Route path="/" element={<Landing />} />
                                    <Route path="/login" element={<Login />} />
                                    <Route path="/register" element={<Register />} />
                                    <Route path="/arise-pro" element={<ProSignup />} />
                                    <Route path="/forgot-password" element={<ForgotPassword />} />
                                    <Route path="/reset-password" element={<ResetPassword />} />
                                    <Route path="/calendar" element={<Dashboard />} />
                                    <Route 
                                        path="/date-selection" 
                                        element={
                                            <ProtectedRoute>
                                                <PersonalDateSelection />
                                            </ProtectedRoute>
                                        } 
                                    />
                                    <Route path="/energy-chart" element={<EnergyChart />} />
                                    <Route path="/energy-chart/:chartId" element={<EnergyChart />} />
                                    <Route path="/admin" element={<AdminEnergyChart />} />
                                    <Route path="/admin/:chartId" element={<AdminEnergyChart />} />
                                    <Route path="/admin/dashboard" element={<AdminDashboard />} />
                                    <Route path="/admin-dashboard" element={<AdminDashboard />} />
                                    <Route path="/admin/guest-profiles" element={<GuestProfiles />} />
                                    <Route 
                                        path="/personal-analysis" 
                                        element={
                                            <ProtectedRoute>
                                                <PersonalAnalysis />
                                            </ProtectedRoute>
                                        } 
                                    />
                                    <Route 
                                        path="/settings" 
                                        element={
                                            <ProtectedRoute>
                                                <Settings />
                                            </ProtectedRoute>
                                        } 
                                    />
                                    <Route path="/crimson-horse" element={<CrimsonHorse />} />
                                    <Route path="/hair-cutting" element={<HairCuttingDays />} />
                                    <Route path="/subscription" element={<Subscription />} />
                                    <Route path="/subscription/success" element={<SubscriptionSuccess />} />
                                    <Route path="/subscription/cancel" element={<SubscriptionCancel />} />
                                </Routes>
                            </main>
                            <Footer />
                            <Toaster />
                        </div>
                    </BrowserRouter>
                </AuthProvider>
            </LanguageProvider>
        </ThemeProvider>
    );
}

export default App;
